/**
 * Мини проводник для просмотра файлов и папок
 *
 * Комопзиция:
 *  - FolderTree(root)
 *  - FolderList
 *  - FolderListItem
 *  - FolderActions
 *
 * =====FolderTree=====
 *  Родитель-обертка для остальных компонентов.
 *  Запрашивает список папок со всем содержимым
 *  Секция предпросмотра выбранного изображения
 *  Отселживает текущий выбранный элемент
 *  Отслеживает текущую открытую директорию
 *  Попробовать сделать Breadcrumbs.
 *  При нажатии на родительский BreadCrumb(самый верхний) закрываем текущую папку
 *  Текстовое поле с фильтрацией по имени
 *
 * =====FolderList=====
 *  Рендер папок/подпапок и файлов из пропсов
 *  Подразумеваем папку
 *  Используем рекурсию
 *
 * =====FolderListItem=====
 *  Подразумевает файл
 *  Отрисовка конкретного элемента из древовидного списка
 *  Выбор конкретного файла
 *
 * =====FolderActions=====
 *  Поиск файла по имени сортировка
 *  Кнопка "Ссылка", активна если выбран файл
 */

import { useEffect, useRef, useState } from "react";
import { getMediaTree } from "../../utils/API/pddMethods";
import { useStore } from "../../hooks/store";
import { Breadcrumbs, CircularProgress, Link } from "@mui/material";
import FolderList from "./FolderList";
import { findInTree } from "../../utils/config";
import * as React from "react";
import { emphasize, styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: (theme.vars || theme).palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(theme.palette.grey[100], 0.06),
      ...theme.applyStyles("dark", {
        backgroundColor: emphasize(theme.palette.grey[800], 0.06),
      }),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[100], 0.12),
      ...theme.applyStyles("dark", {
        backgroundColor: emphasize(theme.palette.grey[800], 0.12),
      }),
    },
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  };
}); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

export default function FolderTree() {
  const setAlert = useStore((s) => s.setAlert);

  const [treeState, setTreeState] = useState({
    folderList: [],
    selectedFolder: { id: null, name: null },
    selectedFile: { id: null, name: null },
    filterQuery: "",
    loading: false,
  });

  const setLoading = () => {
    setTreeState((prev) => ({ ...prev, loading: true }));
  };
  const stopLoading = () => {
    setTreeState((prev) => ({ ...prev, loading: false }));
  };

  const handleFolderSelect = (folder) => {
    const selected =
      folder.id === treeState.selectedFolder.id
        ? { id: null, name: null }
        : folder;
    if (selected.id === null) {
      setTreeState((prev) => ({
        ...prev,
        selectedFolder: selected,
        selectedFile: selected,
      }));
    } else
      setTreeState((prev) => ({
        ...prev,
        selectedFolder: selected,
      }));
  };

  const handleFileSelect = (file) => {
    const selected =
      file.id === treeState.selectedFolder.id ? { id: null, name: null } : file;

    setTreeState((prev) => ({
      ...prev,
      selectedFile: selected,
    }));
  };

  const fetchFolderTree = async () => {
    setLoading();
    const res = await getMediaTree();
    if (res.status === 200) {
      setTreeState((prev) => ({
        ...prev,
        folderList: [res.data],
      }));
    } else {
      setAlert(res.data, "error");
    }
    stopLoading();
  };

  useEffect(() => {
    fetchFolderTree();
  }, []);

  return (
    <section
      style={{
        // width: "100%",

        height: 300,
        // maxHeight: 400,
        display: "flex",
        // alignItems: "center",
        // justifyContent: "center",
        flexDirection: "column",
      }}
      className="main">
      {treeState.loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            alignItems: "center",
            gap: 20,
          }}>
          <CircularProgress />
          <p>Загрузка директорий...</p>
        </div>
      ) : (
        <>
          <div
            style={{
              position: "sticky",
              display: "flex",
              height: "fit-content",
            }}>
            <Breadcrumbs
              style={{
                width: "100%",
                // position: "absolute",
                flex: 1,
                // alignSelf: "start",
                // width: "30%",
              }}>
              <StyledBreadcrumb label={"img"} />
              {treeState.selectedFolder.id !== null && (
                <StyledBreadcrumb
                  deleteIcon={<CloseIcon />}
                  onDelete={() => handleFolderSelect({ id: null })}
                  label={treeState.selectedFolder.name}
                />
              )}

              {treeState.selectedFile.id !== null && (
                <StyledBreadcrumb label={treeState.selectedFile.name} />
              )}
            </Breadcrumbs>
          </div>
          <FolderList
            selectedFolder={treeState.selectedFolder}
            selectedFile={treeState.selectedFile}
            listData={treeState.folderList}
            handleFileSelect={handleFileSelect}
            hanldeFolderSelect={handleFolderSelect}
          />
        </>
      )}
    </section>
  );
}
